import { render, staticRenderFns } from "./AddMeterialist.vue?vue&type=template&id=1ba933da"
import script from "./AddMeterialist.vue?vue&type=script&lang=js"
export * from "./AddMeterialist.vue?vue&type=script&lang=js"
import style0 from "./AddMeterialist.vue?vue&type=style&index=0&id=1ba933da&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports